import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import LoginPage from './login/LoginPage'
import LogoutPage from './login/LogoutPage'
import Sifrant from './components/Sifrant'
import PravicePridelava from './components/PravicePridelava'
import PravicePredelava from './components/PravicePredelava'
import Pridelava from './components/Pridelava'
import Gerk from './components/Gerk'
//import GerkPrint from './components/GerkPrint'

import DodajPridelovalca from './components/DodajPridelovalca'
import DodajKulture from './components/DodajKulture'
import DodajZivali from './components/DodajZivali'
import DodajProizvode from './components/DodajProizvode'
import DodajKontrole from './components/DodajKontrole'
import DodajOdlocbe from './components/DodajOdlocbe'
import DodajCertifikate from './components/DodajCertifikate'

import VsiGerki from './components/VsiGerki'
import Kulture from './components/Kulture'
import Zivali from './components/Zivali'
import Proizvodi from './components/Proizvodi'
import Kontrole from './components/Kontrole'
import Odlocbe from './components/Odlocbe'
import Certifikati from './components/Certifikati'
import Pridelovalec from './components/Pridelovalec'

import Predelava from './components/Predelava'
import KontrolePredelava from './components/KontrolePredelava'
import Dejavnosti from './components/Dejavnosti'
import CertifikatiPredelava from './components/CertifikatiPredelava'
import DislociraneEnote from './components/DislociraneEnote'

import DodajPredelovalca from './components/DodajPredelovalca'
import Predelovalec from './components/Predelovalec'
import DodajDejavnosti from './components/DodajDejavnosti'
import DodajDislociraneEnote from './components/DodajDislociranoEnoto'

import DodajKontrolePredelava from './components/DodajKontrolePredelava'
import DodajCertifikatPredelava  from './components/DodajCertifikatePredelava'


import CertifikatiJavno  from './components/CertifikatiJavno'
//import CertifikatJavno  from './components/CertifikatJavno'
const GerkPrint = () => import ('./components/GerkPrint')
const CertifikatJavno = () => import ('./components/CertifikatJavno')
const CertifikatPredogled = () => import ('./components/CertifikatPredogled')
const CertifikatInput = () => import ('./components/CertifikatInput')

import InputiIskanje  from './components/InputiIskanje'


import {store} from './store/index.js'
import App from './App'

 

Vue.use(Router)

//export default 
 export const router =  new Router({
  mode: 'history',

  routes: [

    {
      path: '/kontrolniList',
      name: 'kontrolniList',
      //children: [
      //{
      //path: '/kontrolniList',
      //name: 'kontrolniList',
      component: GerkPrint,
       props: true
      //}
    //]
      
    },
      {
      path: '/javno/certifikat/:certifikatid',
      name: 'certifikatJavno',
      component: CertifikatPredogled,
      props: true
    },
    {
      path: '/interno/certifikat/:certifikatid',
      name: 'certifikatInterno',
      component: CertifikatPredogled,
      props: true
    },
    {
      path: '/interno/certifikatp/:certifikatid',
      name: 'certifikatPInterno',
      component: CertifikatPredogled,
      props: true
    },
    {
      path: '/inputi/:inputid',
      name: 'input',
      component: CertifikatInput,
      props: true
    },
    // loads Home component
    {
      path: '/',
      name: 'app',
      component: App,
      children: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/inputi',
      name: 'inputi',
      component: InputiIskanje
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage
    },
     {
      path: '/sifrant',
      name: 'sifrant',
      component: Sifrant,
      meta: {
                requiredRoles: ["MKGP"] 
      }
    },
      {
      path: '/pravicePridelava',
      name: 'pravicePridelava',
      component: PravicePridelava,
      meta: {
                requiredRoles: ["MKGP"] 
      }

    },
      {
      path: '/pravicePredelava',
      name: 'pravicePredelava',
      component: PravicePredelava,
      meta: {
                requiredRoles: ["MKGP"] 
      }
    },
    ,
    {
      path: '/pridelava/:sezona?',
      name: 'pridelava',
      component: Pridelava,
      props: true
    },
     {
      path: '/pridelava/gerk/:sezona/:pridelovalecid',
      name: 'gerk',
      component: Gerk,
      props: true
    },
    {
      path: '/pridelava/dodajPridelovalca/:sezona/',
      name: 'dodajPridelovalca',
      component: DodajPridelovalca,
      props: true
    },
     {
      path: '/pridelava/pridelovalec/:sezona/:pridelovalecid',
      name: 'pridelovalec',
      component: Pridelovalec,
      props: true
    },
    {
      path: 'pridelava/kultura/:sezona/:pridelovalecid',
      name: 'kultura',
      component: DodajKulture,
      props: true
    },
     {
      path: 'pridelava/zival/:sezona/:pridelovalecid',
      name: 'zival',
      component: DodajZivali,
      props: true
    },
     {
      path: 'pridelava/proizvod/:sezona/:pridelovalecid',
      name: 'proizvod',
      component: DodajProizvode,
      props: true
    },
     {
      path: '/pridelava/kontrola/:sezona/:pridelovalecid',
      name: 'kontrola',
      component: DodajKontrole,
      props: true
    },
     {
      path: '/pridelava/odlocba/:sezona/:pridelovalecid',
      name: 'odlocba',
      component: DodajOdlocbe,
      props: true
    },
     {
      path: '/pridelava/certifikat/:sezona/:pridelovalecid',
      name: 'certifikat',
      component: DodajCertifikate,
      props: true
    },
      {
      path: '/vsiGerki/:sezona?',
      name: 'vsiGerki',
      component: VsiGerki,
      props: true
    },
    {
      path: '/kulture/:sezona?',
      name: 'kulture',
      component: Kulture,
      props: true
    },
    {
      path: '/zivali/:sezona?',
      name: 'zivali',
      component: Zivali,
      props: true
    },
     {
      path: '/proizvodi/:sezona?',
      name: 'proizvodi',
      component: Proizvodi,
      props: true
    },
     {
      path: '/kontrole/:sezona?',
      name: 'kontrole',
      component: Kontrole,
      props: true
    },
     {
      path: '/odlocbe/:sezona?',
      name: 'odlocbe',
      component: Odlocbe,
      props: true
    },
    {
      path: '/certifikati/:sezona?',
      name: 'certifikati',
      component: Certifikati,
      props: true
    },
//predelava routes
    {
      path: '/predelava/:sezona?',
      name: 'predelava',
      component: Predelava,
      props: true
    },
    {
      path: '/predelava/dodajPredelovalca/:sezona/',
      name: 'dodajPredelovalca',
      component: DodajPredelovalca,
      props: true
    },
    {
      path: '/predelava/predelovalec/:sezona/:predelovalecid',
      name: 'predelovalec',
      component: Predelovalec,
      props: true
    },
    {
      path: '/dislociraneEnote/:sezona?',
      name: 'dislociraneEnote',
      component: DislociraneEnote,
      props: true
    },
     {
      path: 'predelava/dislociraneEnote/:sezona/:predelovalecid',
      name: 'dislociranaEnota',
      component: DodajDislociraneEnote,
      props: true
    },
    {
      path: '/dejavnosti/:sezona?',
      name: 'dejavnosti',
      component: Dejavnosti,
      props: true
    },
     {
      path: 'predelava/dejavnost/:sezona/:predelovalecid',
      name: 'dejavnost',
      component: DodajDejavnosti,
      props: true
    },

     {
      path: '/kontrolePredelava/:sezona?',
      name: 'kontrolePredelava',
      component: KontrolePredelava,
      props: true
    },
     {
      path: '/predelava/kontrole/:sezona/:predelovalecid',
      name: 'kontrolaPredelava',
      component: DodajKontrolePredelava,
      props: true
    },
     
    {
      path: '/certifikatiPredelava/:sezona?',
      name: 'certifikatiPredelava',
      component: CertifikatiPredelava,
      props: true
    },
     {
      path: '/predelava/certifikati/:sezona/:predelovalecid',
      name: 'certifikatPredelava',
      component: DodajCertifikatPredelava,
      props: true
    },
     

     {
      path: '/javno/certifikati/:isci',
      name: 'certifikatiJavno',
      component: CertifikatiJavno,
      props: true
    },
   
   
    {
       path: '/logout',
      name: 'logout',
      component: LogoutPage
    }
  ]
  },
  ]
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login','/', '/home','/javno/certifikati','/javno/certifikat','/inputi','/input'];
  const publicPagesNames = ['/login','/', '/home','certifikatJavno','certifikatiJavno','inputi','input'];
  console.log(to);
  const authRequired = !(publicPages.includes(to.path)||publicPagesNames.includes(to.name)) ;
  const loggedIn = localStorage.getItem('user');
  const loggedInTime = localStorage.getItem('userAuthenticated');
  var sessionExpired=false;
  if (loggedInTime) {
    const currentTime = new Date().getTime();
    const fourHoursInMillis = 4 *60 * 60 * 1000; // 4 hours in milliseconds
    sessionExpired=(currentTime - parseInt(loggedInTime)) >= fourHoursInMillis;
  }
  //let role=store.userDetails.vloga;
  //console.log("VLOGA IZ ROUTER:");
  //const store = require('./store/index.js'); 
   //store.dispatch('alert/error', "Za obisk te strani morate biti prijavljeni!", { root: true });
  
  if (authRequired && !loggedIn) {
      store.dispatch('alert/error', "Za obisk te strani morate biti prijavljeni!", { root: true });
       store.dispatch('account/logout');
    return next('/login');
  }
  else if(loggedInTime&&sessionExpired){
      //logout user
      console.log("seja potekla");
      store.dispatch('alert/error', "Seja je potekla. Ponovno se prijavite", { root: true });
      store.dispatch('account/logout');
      
      return next('/login'); 
      
  }
  //if(to)

  next();
});


